/* unplugin-vue-components disabled */import { render } from "./student.vue?vue&type=template&id=29c27478&scoped=true&ts=true"
import script from "./student.vue?vue&type=script&lang=ts"
export * from "./student.vue?vue&type=script&lang=ts"

import "./student.vue?vue&type=style&index=0&id=29c27478&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\17532\\Desktop\\智慧校园\\school-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c27478"]])

export default __exports__